// Copyright (C) 2019-2022 Intel Corporation
// Copyright (C) 2022 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

const API_BASE_URL = '/vai/cvat'
const config = {
    backendAPI: `${API_BASE_URL}/api`,
    organizationID: null,
    origin: '',
    uploadChunkSize: 100,
    removeUnderlyingMaskPixels: false,
};

export default config;
